import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// Obtener días especiales por calendario
export const getDiasEspecialesByCalendario = async (calendarioId, anio = null) => {
    let url = `${API_URL}/api/dias-especiales/calendario/${calendarioId}`;
    if (anio) url += `?anio=${anio}`;

    const response = await axios.get(url, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
    });
    return response.data;
};

// Obtener días especiales por calendario de colaboradores
export const getDiasEspecialesByCalendarioColab = async (calendarioId, anio = null) => {
    let url = `${API_URL}/api/dias-especiales/calendario-colab/${calendarioId}`;
    if (anio) url += `?anio=${anio}`;

    const response = await axios.get(url, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
    });
    return response.data;
};

// Obtener día especial por ID
export const getDiaEspecial = async (id) => {
    const response = await axios.get(`${API_URL}/api/dias-especiales/${id}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
    });
    return response.data;
};

// Crear día especial
export const createDiaEspecial = async (diaData) => {
    const response = await axios.post(`${API_URL}/api/dias-especiales`, diaData, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
    });
    return response.data;
};

// Crear múltiples días especiales
export const createMultipleDiasEspeciales = async (dias, calendarioId) => {
    const response = await axios.post(`${API_URL}/api/dias-especiales/multiple`, {
        dias,
        calendario_laboral_id: calendarioId
    }, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
    });
    return response.data;
};

// Actualizar día especial
export const updateDiaEspecial = async (id, diaData) => {
    const response = await axios.put(`${API_URL}/api/dias-especiales/${id}`, diaData, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
    });
    return response.data;
};

// Eliminar día especial
export const deleteDiaEspecial = async (id) => {
    const response = await axios.delete(`${API_URL}/api/dias-especiales/${id}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
    });
    return response.data;
};
